/**
 * Waitlist RPC definitions
 *
 * Public endpoints for waitlist functionality - no authentication required.
 *
 * @since 1.0.0
 */
import { Rpc, RpcGroup } from "@effect/rpc";
import { Waitlist } from "@fm/db/models/Waitlist";
import { Schema } from "effect";

// ============================================================================
// Request Schemas
// ============================================================================

/**
 * Request schema for joining the waitlist
 * @since 1.0.0
 */
export const WaitlistJoinRequest = Schema.Struct({
  email: Schema.NonEmptyTrimmedString,
  name: Schema.optional(Schema.String),
});

// ============================================================================
// Error Types
// ============================================================================

/**
 * Database error
 * @since 1.0.0
 */
export class DatabaseError extends Schema.TaggedError<DatabaseError>()(
  "DatabaseError",
  {
    message: Schema.optional(Schema.String),
  },
) {}

/**
 * Validation error for invalid input
 * @since 1.0.0
 */
export class ValidationError extends Schema.TaggedError<ValidationError>()(
  "ValidationError",
  {
    field: Schema.String,
    message: Schema.String,
  },
) {}

// ============================================================================
// RPC Group
// ============================================================================

/**
 * Waitlist RPC group
 *
 * Public endpoints for waitlist functionality - no authentication required.
 *
 * @since 1.0.0
 */
export class WaitlistRpcs extends RpcGroup.make(
  Rpc.make("waitlist.join", {
    payload: WaitlistJoinRequest,
    success: Waitlist.json,
    error: Schema.Union(ValidationError, DatabaseError),
  }),
) {}
